import axios from "../../api/axyos";

export type OAuthProvider = "google" | "facebook";

const trimTrailingSlashes = (value: string): string => value.replace(/\/+$/, "");

const shouldReplaceLocalhostUrl = (value: string): boolean => {
  if (typeof window === "undefined") return false;
  const frontendHost = window.location.hostname;
  if (!frontendHost || frontendHost === "localhost" || frontendHost === "127.0.0.1") return false;

  try {
    const parsed = new URL(value);
    return parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1";
  } catch (_error) {
    return false;
  }
};

const shouldReplaceInsecureUrl = (value: string): boolean => {
  if (typeof window === "undefined" || window.location.protocol !== "https:") return false;

  try {
    const parsed = new URL(value);
    return parsed.protocol === "http:";
  } catch (_error) {
    return false;
  }
};

const getWindowHostApiBaseUrl = (): string | null => {
  if (typeof window === "undefined") return null;
  return `${window.location.origin}/api`;
};

export const getApiBaseUrl = (): string => {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv) {
    const normalizedEnv = trimTrailingSlashes(fromEnv);
    if (shouldReplaceLocalhostUrl(normalizedEnv) || shouldReplaceInsecureUrl(normalizedEnv)) {
      return trimTrailingSlashes(getWindowHostApiBaseUrl() || normalizedEnv);
    }
    return normalizedEnv;
  }

  const fromAxios = axios.defaults.baseURL || "";
  if (fromAxios) {
    const normalizedAxios = trimTrailingSlashes(fromAxios);
    if (shouldReplaceLocalhostUrl(normalizedAxios) || shouldReplaceInsecureUrl(normalizedAxios)) {
      return trimTrailingSlashes(getWindowHostApiBaseUrl() || normalizedAxios);
    }
    return normalizedAxios;
  }

  return trimTrailingSlashes(getWindowHostApiBaseUrl() || window.location.origin);
};

export const getOAuthLoginUrl = (provider: OAuthProvider): string => {
  const customGoogle = process.env.REACT_APP_GOOGLE_AUTH_URL;
  const customFacebook = process.env.REACT_APP_FACEBOOK_AUTH_URL;

  if (provider === "google" && customGoogle) return customGoogle;
  if (provider === "facebook" && customFacebook) return customFacebook;

  return `${getApiBaseUrl()}/auth/${provider}`;
};

export const clearOAuthTokenFromUrl = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete("accessToken");
  url.searchParams.delete("token");
  url.hash = "";
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}`);
};
